<template>
  <router-view />

  <v-app class="rounded rounded-md">
    <!-- アプリバー -->
    <TopBar @toggle-drawer="drawer = !drawer" />
    <!-- メニュー -->
    <TopMenu v-model="drawer" />
    <!-- メイン -->
    <v-main class="align-center justify-center" style="min-height: 300px;">
      <!-- <v-btn-toggle v-model="icon" >
        <v-btn class="bg-red"><v-icon></v-icon><span>スポーツ店</span></v-btn>
        <v-btn><v-icon></v-icon><span>スポーツ施設</span></v-btn>
        <v-btn><v-icon></v-icon><span>スポーツ団体</span></v-btn>
        <v-btn><v-icon></v-icon><span>サークル<br>チーム</span></v-btn>
        <v-btn><v-icon></v-icon><span>スクール</span></v-btn>
      </v-btn-toggle> -->


      <!-- 新着店舗 -->
      <v-container class="">
        <v-row class="bg-red mt-2 px-2 py-1">
          スポーツ店一覧
        </v-row>
        <v-row>
          <v-text-field class="ma-2" density="compact" prepend-inner-icon="mdi-magnify" variant="solo-filled" flat
            hide-details v-model="keyword" @keyup.enter="search" @click:prepend-inner="search" placeholder="キーワードで検索"></v-text-field>
        </v-row>
        <v-row class="scroll-x-content">
          <v-col v-for="item in sport_store" :key="item.sport_id" cols="12" xs="12" sm="12" md="12" lg="12" xl="6">
            <v-card :to="{ name: 'sportsstoredetail', params: {sportsStoreId: item.sports_store_id} }" hover ripple class="mx-auto" max-width="100%">
              <v-carousel height="250" :show-arrows="false">
                <v-carousel-item v-for="slide in item.sports_store_photo" :key="slide.record_id" :src="slide.path" cover  cycle hide-delimiter-background>
                </v-carousel-item>
              </v-carousel>

              <v-card-title class="flex-column align-start">
                <h3 class="text-h6">
                  {{ item.store_name }}
                </h3>
                <div class="text--primary">
                  {{ item.appeal_point }}
                </div>
              </v-card-title>

            </v-card>
            <!-- <v-card class="mx-auto" max-width="90%">
              <v-card-text>
                <v-row class="justify-space-between">
                  <v-col>
                    <p class="text-h6 text--primary">
                      {{ item.store_name }}
                    </p>
                    <div class="text--primary">
                      {{ item.appeal_point }}
                    </div>
                  </v-col>
                </v-row>
                <div class="text-center">
                  <v-chip class="ma-1 text--primary" v-for="chip in item.sports_store_sports_gear" :key="chip.recode_id">
                    {{ chip.sport_id }}
                  </v-chip>
                </div>
                <v-carousel height="auto" v-if="item.sports_store_photo.length" cycle hide-delimiter-background show-arrows-on-hover>
                  <v-carousel-item v-for="slide in item.sports_store_photo" :key="slide.record_id">
                    <v-sheet>
                      <v-row class="align-center" justify="center">
                        <v-img :src="slide.path"></v-img>
                      </v-row>
                    </v-sheet>
                  </v-carousel-item>
                </v-carousel>
              </v-card-text>
              <v-card-actions>
                <v-btn variant="text" color="teal-accent-4" @click="item.reveal = true">
                  Learn More
                </v-btn>
              </v-card-actions>
            </v-card> -->
          </v-col>
        </v-row>
      </v-container>

      <!-- チーム・サークル -->

    </v-main>
    <!-- フッター（青いバーの原因なので非表示化） -->
    <!-- <v-footer app color="primary"></v-footer> -->
  </v-app>
</template>

<script>
// import Vue from 'vue'
import TopBar from '@/components/TopBar.vue'
import TopMenu from '@/components/TopMenu.vue'
// import { library } from '@fortawesome/fontawesome-svg-core'
// import { faShop } from  '@fortawesome/free-solid-svg-icons'
// import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import axios from 'axios'

// export default {
//   data() {
//     return {
//       faShop
//     }
//   }
// }
// library.add(faShop)

// Vue.component('font-awesome-icon', FontAwesomeIcon)

export default {
  name: 'App',
  components: {
    TopBar,
    TopMenu,
  },
  data: () => ({
    drawer: false,
    reveal: false,
    authorize: false,
    user: null,
    sport_store: [],
    keyword: ''
  }),
  created: function () {
    this.getData()
    axios.get(
      process.env.VUE_APP_API_URL + '/api/logincheck',
      { headers: { "Authorization": JSON.stringify(this.$store.getters.getToken) } }
    ).then(response => {
      if (response.status == 200 && response.data.user) {
        this.user = response.data.user
        this.authorize = true
      } else {
        this.authorize = false
      }
    }).catch(() => {
      this.authorize = false
    })
  },
  methods: {
    getData() {
      axios.get(process.env.VUE_APP_API_URL + '/sportsstore/list')
        .then(response => {
          console.log(response.data); // mockData
          console.log(response.status); // 200
          this.sport_store = response.data.sport_store
        })
    },
    search() {
      if (!this.keyword.trim()) {
        this.getData();
        return;
      }
      axios.post(process.env.VUE_APP_API_URL + '/sportsstore/search', { keyword: this.keyword })
        .then(response => {
          this.sport_store = response.data.sport_store
        })
        .catch(err => {
          console.error(err);
        });
    },
  },
}
</script>